import { render, staticRenderFns } from "./BraintreeProvider.vue?vue&type=template&id=2c8cc710&"
import script from "./BraintreeProvider.vue?vue&type=script&lang=ts&"
export * from "./BraintreeProvider.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports